import { authApi } from 'api';

const safeMode = false;

export const getSeasons = async (clubId) => {
  return await authApi.get(`/Seasons?clubId=${clubId}`);
};

export const getActiveSeason = async (clubId) => {
  return await authApi.get(`/Seasons/current?clubId=${clubId}`);
};

export const checkAges = async (clubId) => {
  return await authApi.post(`/Seasons/check-athlete-ages`, { clubId });
};

export const updateAges = async (clubId, authorizationPin) => {
  return await authApi.post(`/Seasons/update-athlete-ages`, {
    clubId,
    authorizationPin,
  });
};

export const startNewSeason = async (clubId, seasonId, authorizationPin) => {
  if (safeMode) {
    console.log('SAFE MODE - startNewSeason API call would be:', {
      method: 'POST',
      url: `/Seasons/${seasonId}/start`,
      body: {
        clubId,
        authorizationPin,
      },
    });
    return {
      data: { message: 'API not called in safe mode - startNewSeason' },
    };
  }
  return await authApi.post(`/Seasons/${seasonId}/start`, {
    clubId,
    authorizationPin,
  });
};

export const addSeason = async (payload) => {
  if (safeMode) {
    console.log('SAFE MODE - addSeason API call would be:', {
      method: 'POST',
      url: '/Seasons',
      body: payload,
    });
    return { data: { message: 'API not called in safe mode - addSeason' } };
  }
  return await authApi.post(`/Seasons`, payload);
};

export const updateSeason = async (seasonId, payload) => {
  if (safeMode) {
    console.log('SAFE MODE - updateSeason API call would be:', {
      method: 'PUT',
      url: `/Seasons/${seasonId}`,
      body: payload,
    });
    return { data: { message: 'API not called in safe mode - updateSeason' } };
  }
  return await authApi.put(`/Seasons/${seasonId}`, payload);
};

export const deleteSeason = async (clubId, seasonId, authorizationPin) => {
  if (safeMode) {
    console.log('SAFE MODE - deleteSeason API call would be:', {
      method: 'DELETE',
      url: `/Seasons/${seasonId}?clubId=${clubId}`,
      body: { authorizationPin },
    });
    return { data: { message: 'API not called in safe mode - deleteSeason' } };
  }
  return await authApi.delete(`/Seasons/${seasonId}?clubId=${clubId}`, {
    data: { authorizationPin },
  });
};
